(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["availability-request-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('availability-request')) {
    class AvailabilityRequest extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.availability-request__panel');

        if (!this.details || !this.summary || !this.panel) return;

        if (this.details.open) this.panel.classList.add('is-open');

        this.summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.details.open) {
            this.close();
          } else {
            this.open();
          }
        });
      }

      open() {
        this.details.open = true;
        window.requestAnimationFrame(() => this.panel.classList.add('is-open'));
      }

      close() {
        this.panel.classList.remove('is-open');

        const finish = () => {
          if (!this.panel.classList.contains('is-open')) this.details.open = false;
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          finish();
          return;
        }

        this.panel.addEventListener('transitionend', finish, { once: true });
        window.setTimeout(finish, 320);
      }
    }

    customElements.define('availability-request', AvailabilityRequest);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
    function artworkRatio(item) {
      const card = item.querySelector('.rf-card');
      return Number.parseFloat(card?.style.getPropertyValue('--rf-art-ratio')) || 1;
    }

    function groupItems(items, columns) {
      return items.reduce((rows, item, index) => {
        const rowIndex = Math.floor(index / columns);
        if (!rows[rowIndex]) rows[rowIndex] = [];
        rows[rowIndex].push(item);
        return rows;
      }, []);
    }

    function gridColumns(grid, itemCount) {
      const suffix = window.matchMedia('(min-width: 990px)').matches ? 'desktop' : 'tablet-down';
      const className = Array.from(grid.classList).find((name) => new RegExp(`^grid--\\d+-col-${suffix}$`).test(name));
      const columns = Number.parseInt(className?.match(/\\d+/)?.[0], 10) || 1;
      return Math.min(columns, itemCount);
    }

    function resetGrid(grid, items) {
      grid.classList.remove('rf-product-grid--justified');
      items.forEach((item) => {
        item.style.removeProperty('flex');
        item.style.removeProperty('max-width');
      });
    }

    function layoutGrid(grid) {
      const items = Array.from(grid.querySelectorAll(':scope > .grid__item')).filter((item) => item.querySelector('.rf-product-card'));
      if (!items.length || !grid.clientWidth || grid.classList.contains('slider')) {
        resetGrid(grid, items);
        return;
      }

      const columns = gridColumns(grid, items.length);
      const rows = groupItems(items, columns);
      const gap = Number.parseFloat(window.getComputedStyle(grid).columnGap) || 0;
      const artworkHeight = Math.min(...rows.map((row) => {
        const ratios = row.reduce((total, item) => total + artworkRatio(item), 0);
        return (grid.clientWidth - gap * (row.length - 1)) / ratios;
      }));

      grid.classList.add('rf-product-grid--justified');
      rows.forEach((row) => {
        row.forEach((item) => {
          const width = artworkHeight * artworkRatio(item);
          item.style.flex = `0 0 ${width}px`;
          item.style.maxWidth = `${width}px`;
        });
      });
    }

    function initGrid(grid) {
      if (grid.closest('collection-component')) return;
      if (grid.dataset.rfCardGridInitialized === 'true') return;
      grid.dataset.rfCardGridInitialized = 'true';

      const updateLayout = () => layoutGrid(grid);
      updateLayout();

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(updateLayout);
        observer.observe(grid);
      } else {
        window.addEventListener('resize', updateLayout);
      }

      const observer = new MutationObserver(updateLayout);
      observer.observe(grid, { childList: true });
    }

    function initAll(root = document) {
      if (root.matches?.('.product-grid')) initGrid(root);
      root.querySelectorAll?.('.product-grid').forEach(initGrid);
    }

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
